import React from 'react';
import { useTranslation } from 'react-i18next';

import { convertKeysToCamelCase } from 'helpers/baseHelper';
import style from 'assets/scss/components/ContactFormCard.module.scss';
import image from '../assets/images/bubbles.svg';
import useContact from '../hooks/useContact';
import TurnstileWidget from './common/TurnstileWidget';

function ContactFormCard() {
  const { t } = useTranslation();
  const { submitContactForm, register, handleSubmit, setIsChecked, isChecked, errors, turnstileProps } = useContact();
  const {
    wrapper,
    wrapperBubble,
    form,
    formError,
    formHeader,
    formContent,
    formContentInputSmall,
    formContentInputLarge,
    gdprAcceptance,
    gdprCheck,
    turnstile,
  } = convertKeysToCamelCase(style);

  return (
    <section className={`${wrapper} contact-form max-width`}>
      <div className={wrapperBubble}>
        <img src={image} alt="img" />
      </div>
      <form className={form} onSubmit={handleSubmit(submitContactForm)}>
        <div className={formHeader}>
          <h2>{t('contact.form.title')}</h2>
          <p>{t('contact.form.description')}</p>
        </div>
        <div className={formContent}>
          <div className={formContentInputSmall}>
            <span>
              <label>{t('contact.form.input.firstName.label')} *</label>
              <input {...register('firstName')} placeholder={t('contact.form.input.firstName.placeholder')} />
              {errors?.firstName && <span className={formError}>{t(`validation.${errors?.firstName?.message}`)}</span>}
            </span>
            <span>
              <label>{t('contact.form.input.lastName.label')} *</label>
              <input {...register('lastName')} placeholder={t('contact.form.input.lastName.placeholder')} />
              {errors?.lastName && <span className={formError}>{t(`validation.${errors?.lastName?.message}`)}</span>}
            </span>
          </div>
          <div className={formContentInputLarge}>
            <span>
              <label>{t('contact.form.input.email.label')} *</label>
              <input {...register('email')} placeholder={t('contact.form.input.email.placeholder')} />
              {errors?.email && <div className={formError}>{t(`validation.${errors?.email?.message}`)}</div>}
            </span>
            <span>
              <label>{t('contact.form.input.message.label')} *</label>
              <textarea
                {...register('message')}
                placeholder={t('contact.form.input.message.placeholder')}
                rows="4"
              />
              {errors?.message && <div className={formError}>{t(`validation.${errors?.message?.message}`)}</div>}
            </span>
          </div>
          <div className={gdprAcceptance}>
            <input
              name="gdpr"
              type="checkbox"
              onChange={() => setIsChecked(!isChecked)}
              checked={isChecked}
              value={isChecked}
            />
            <div>{t('contact.form.gdpr_text')}</div>
          </div>
          {!isChecked && <div className={gdprCheck}>{t(`validation.required`)}</div>}
          <TurnstileWidget {...turnstileProps} className={turnstile} />
          <button type="submit">{t('contact.form.button')}</button>
        </div>
      </form>
    </section>
  );
}

export default ContactFormCard;
